const SERVICE_ID = "service_1vq2fjw";
const USER_ID = "CeezOSMwNQYdjy1XU";
const TEMPLATE_ID = "template_jmmdjib";

export { SERVICE_ID, USER_ID, TEMPLATE_ID };
